module.exports = __webpack_public_path__ + "img/spain-transport-accidents-female.2ce25315.png";